import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  button: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    borderRadius: 8,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main,
      boxShadow: 'none'
    }
  },

  buttonProgress: {
    color: theme.palette.green_200.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}))
